<template>
  <b-modal v-model="display"
           @ok="saveData"
           @cancel="sendResultBack"
           :no-close-on-backdrop="true"
           :no-close-on-esc="true"
           :hide-header-close="true"
           :ok-disabled="isSaving">
    <div slot="modal-title">
      {{ $t('message.my_listings.add_pet_types') }}
    </div>
    <div>
      <div class="d-flex bg-light border rounded p-2 justify-content-center align-items-center mb-3" 
           :class="[selectedPetTypes.includes(petType) ? 'border-info' : 'border-light']"
           v-for="petType in globalState.petTypes">
        <div class="flex-fill">
          <h4 class="p-0 m-0">
            <label class="form-check-label p-0 m-0 d-block" :for="`petType${petType.id}`">
              <img :src="petType.image_url" with="48">
              {{ petType | multiLangName }}
            </label>
          </h4>
        </div>
        <div>
          <input class="" type="checkbox" v-model="selectedPetTypes" :value="petType" :id="`petType${petType.id}`">
        </div>
      </div>
      <input type="text" 
             class="form-control input-jumbo"
             :class="{'form-alert': hasOtherPetType() && errorNoRemark}"
             :placeholder="$t('message.my_listings.pet_remark_placeholder')" 
             v-model="remark"
             v-show="hasOtherPetType()">
      <div class="mt-1 text-remark -status-alert" v-if="hasOtherPetType() && errorNoRemark">
        {{ $t('message.required_field') }}
      </div>
    </div>
    <div slot="modal-cancel">{{ $t('message.button.close') }}</div>
    <div slot="modal-ok">{{ isSaving ? $t('message.button.loading') : $t('message.button.save') }}</div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    data () {
      return {
        display: false,
        isSaving: false,
        selectedPetTypes: [],
        remark: null,
        userPlacePetTypes: null,
        errorNoRemark: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        preCheckoutData: 'booking/getPreCheckoutData',
        listing: 'listing/getListingDetail'
      })
    },
    watch: {
      remark () {
        if (this.remark) {
          this.errorNoRemark = false
        }
      }
    },
    methods: {
      hasOtherPetType () {
        const petTypes = this.globalState.petTypes
        const hasOtherPetType = petTypes.some(pet =>
          this.selectedPetTypes.includes(pet) && pet.is_other === 1
        )
        return hasOtherPetType
      },
      showModal (status) {
        this.display = status
        if (status) {
          this.selectedPetTypes = []
        }
      },
      closeModal () {
        this.display = false
        this.sendResultBack()
      },
      sendResultBack () {
        const petCount = this.selectedPetTypes.length
        let hasPet = (petCount > 0)
        if (petCount === 1 && this.hasOtherPetType() && !this.remark) {
          hasPet = false
          this.selectedPetTypes = []
        }
        if (hasPet && petCount && this.remark) {
          this.selectedPetTypes.forEach(petType => {
            if (petType.is_other) {
              petType.remark = this.remark
            }
          })
        }
        this.$emit('onUpdateResult', {
          hasPet: hasPet,
          selectedPetTypes: this.selectedPetTypes
        })
      },
      isValid () {
        this.errorNoRemark = false
        let result = true
        if (this.hasOtherPetType() && !this.remark) {
          result = false
          this.errorNoRemark = true
        }
        return result
      },
      async saveData (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        if (this.isValid()) {
          if (this.selectedPetTypes.length) {
            let userPlaceId = null
            if (this.$route.path.startsWith('/user/listings')) {
              if (this.listing) { // For editing user place
                userPlaceId = this.listing.id
              }
            } else if (this.$route.path.startsWith('/booking')) {
              // For booking: checkout page
              if (this.preCheckoutData && this.preCheckoutData.user_place && this.preCheckoutData.user_place.id) {
                userPlaceId = this.preCheckoutData.user_place.id
              }
            }
            if (userPlaceId) {
              this.isSaving = true
              this.userPlacePetTypes = null
              const url = `/users-places/${userPlaceId}/pet-type`
              const petTypeIds = this.selectedPetTypes.map(item => item.id)
              const submitData = {
                pet_type_ids: petTypeIds,
                remark: this.remark
              }
              const { data } = await axios.post(url, submitData)
              this.userPlacePetTypes = data.user_place_pet_types
              this.isSaving = false
            }
          }
          this.closeModal()
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/booking/components/PetTypeModal.vue